<template>
    <div class="idxShow">
        <div class="property" :class="{loading: loading}">
            <swiper :options="swiperOption" style="background-color: #ddddee;" class="swiperMain" ref="swiperMain">
                <swiper-slide v-for="(photo, iPhoto) in property.Photos" :key="iPhoto">
                    <div class="imgHolder">
                        <img :src="photo.Uri1280" @click="openLightbox(iPhoto)">
                    </div>
                </swiper-slide>
<!--                <div class="swiper-pagination" slot="pagination"></div>-->
                <div class="swiper-scrollbar" slot="scrollbar"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
            <swiper :options="swiperOptionThumb" v-show="!loading" :space-between="10" class="swiperThumbs" ref="swiperThumbs">
                <swiper-slide v-for="(photo, iPhoto) in property.Photos" :key="iPhoto" :data-key="iPhoto">
                    <div class="thumbHolder">
                        <img :src="photo.Uri300">
                    </div>
                </swiper-slide>
            </swiper>
            <FsLightbox
                :toggler="lightboxToggle"
                :slide="lightboxSlide"
                :sources="lightboxPhotos"
                type="image"
            />
            <div class="details">
                <span class="address">
                    <span class="street">{{ property.UnparsedFirstLineAddress }}</span>
                    <span class="town">
                        {{ property.City }}, {{ property.StateOrProvince }}
                        {{ property.PostalCode }}
                    </span>
                </span>
                <span class="price">${{ property.ListPrice.toLocaleString() }}</span>
                <ul class="listing-info">
                    <li class="type">{{ property.DaagyPropertyType }}</li>
                    <li class="status">{{ property.MlsStatus }}</li>
                    <li class="mls-id">MLS # {{ property.ListingId }}</li>
                </ul>
                <ul class="property-info">
                    <li class="beds" v-if="property.BedsTotal > 0">
                        {{ property.BedsTotal }}
                        <span class="nowrap">bed{{ property.BedsTotal > 1 ? 's' : '' }}</span>
                    </li>
                    <li class="baths-full" v-if="property.BathsFull > 0">
                        {{ property.BathsFull }}
                        <span class="nowrap">full bath{{ property.BathsFull > 1 ? 's' : '' }}</span>
                    </li>
                    <li class="baths-half" v-if="property.BathsHalf > 0">
                        {{ property.BathsHalf }}
                        <span class="nowrap">half bath{{ property.BathsHalf > 1 ? 's' : '' }}</span>
                    </li>
<!--
                    <li class="lot-size" v-if="property.LotSizeArea > 0">
                        {{ property.LotSizeArea }}
                        <span class="nowrap">{{ property.LotSizeUnits.toLowerCase() }}</span>
                    </li>
-->
                    <li class="lot-size" v-if="property.LotSizeAcres > 0">
                        {{ property.LotSizeAcres }} acres
                    </li>
                    <li class="sq-ft" v-if="property.BuildingAreaTotal > 0">
                        {{ property.BuildingAreaTotal }} <span class="nowrap">sq ft</span>
                    </li>
<!--
                    <li class="garage-spaces" v-if="property.GarageSpaces > 0">
                        {{ property.GarageSpaces }} <span class="nowrap">garage spaces</span>
                    </li>
-->
                </ul>
                <div class="view" v-if="Array.isArray(property.DaagyView) && property.DaagyView.length">
                    Views of: {{ property.DaagyView.join(', ') }}
                </div>
                <div class="waterfront" v-if="Array.isArray(property.DaagyWaterfrontFeatures) && property.DaagyWaterfrontFeatures.length">
                    Waterfront: {{ property.DaagyWaterfrontFeatures.join(', ') }}
                </div>
<!--
                Current price: {{ property.CurrentPrice }}<br>
                Close date: {{ property.CloseDate }}<br>
                Close price: {{ property.ClosePrice }}<br>
-->
            </div>

            <div class="tabs-component">
                <ul role="tablist" class="tabs-component-tabs">
                    <li role="presentation" class="tabs-component-tab" :class="{'is-active': view === VIEWS.description}">
                        <span aria-controls="#property-description" role="tab"
                                class="tabs-component-tab-a" :aria-selected="view === VIEWS.description"
                                @click="view = VIEWS.description">
                            Property Description
                        </span>
                    </li>
                    <li role="presentation" class="tabs-component-tab" :class="{'is-active': view === VIEWS.features}">
                        <span aria-controls="#property-features" role="tab"
                                class="tabs-component-tab-a" :aria-selected="view === VIEWS.features"
                                @click="view = VIEWS.features">
                            Property Features
                        </span>
                    </li>
                    <li role="presentation" class="tabs-component-tab" :class="{'is-active': view === VIEWS.land}">
                        <span aria-controls="#land-information" role="tab"
                                class="tabs-component-tab-a" :aria-selected="view === VIEWS.land"
                                @click="view = VIEWS.land">
                            Land Information
                        </span>
                    </li>
                    <li role="presentation" class="tabs-component-tab" :class="{'is-active': view === VIEWS.tax_deed}">
                        <span aria-controls="#tax-deed-information" role="tab"
                              class="tabs-component-tab-a" :aria-selected="view === VIEWS.tax_deed"
                              @click="view = VIEWS.tax_deed">
                            Tax/Deed Information
                        </span>
                    </li>
                    <li role="presentation" class="tabs-component-tab" :class="{'is-active': view === VIEWS.map}" v-if="hasMap">
                        <span aria-controls="#map" role="tab"
                              class="tabs-component-tab-a" :aria-selected="view === VIEWS.map"
                              @click="view = VIEWS.map">
                            Map
                        </span>
                    </li>
                </ul>
            </div>

            <div class="tab-content remarks" v-if="view === VIEWS.description" id="property-description">
                <p class="desc">{{ property.PublicRemarks }}</p>
            </div>
            <div class="tab-content features" v-if="view === VIEWS.features" id="property-features">
                <ul>
                    <li v-for="item in listDetails('features')">
                        <span class="label">{{ item.label }}</span>:
                        {{ item.value }}
                    </li>
                </ul>
            </div>
            <div class="tab-content features" v-if="view === VIEWS.land" id="land-information">
                <ul>
                    <li v-for="item in listDetails('land')">
                        <span class="label">{{ item.label }}</span>:
                        {{ item.value }}
                    </li>
                </ul>
            </div>
            <div class="tab-content features" v-if="view === VIEWS.tax_deed" id="tax-deed-information">
                <ul>
                    <li v-for="item in listDetails('tax_deed')">
                        <span class="label">{{ item.label }}</span>:
                        {{ item.value }}
                    </li>
                </ul>
            </div>
            <div class="tab-content map" v-show="view === VIEWS.map" id="map" v-if="hasMap">
                <div id="mapHolder">&nbsp;</div>
            </div>
            <div class="property-compliance">
                <span class="listed-by">Listed by {{ property.ListOfficeName || '(not specified)' }}</span>
                <span class="idx-logo-image" v-if="property.DaagyIdxLogoImage"><img :src="property.DaagyIdxLogoImage"></span>
                <span class="idx-logo-text" v-if="property.DaagyIdxLogoText">{{ property.DaagyIdxLogoText }}</span>
            </div>
            <idx-request :listing-id="property.ListingId" />
        </div>
        <footer class="compliance">
            <p>
                Listing data is derived in whole or in part from the Maine IDX and is for consumers' personal,
                noncommercial use only. Dimensions are approximate and not guaranteed. All data should be independently
                verified. Copyright &copy;2023 Maine Real Estate Information System, Inc. All Rights Reserved. Equal
                Housing Opportunity.
            </p>
<!--            <img src="https://cdn.photos.sparkplatform.com/me/20181001152253951779000000.jpg">-->
            <img src="https://daagy.mdiwebsites.com/img/Maine_IDX_Blue.jpg">
            <img src="https://daagy.mdiwebsites.com/img/equal-housing-logo250.png">
        </footer>
    </div>
</template>

<script>
import axios from 'axios';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
// import 'swiper/css/free-mode';
// import 'swiper/css/navigation';
// import 'swiper/css/thumbs';
import FsLightbox from 'fslightbox-vue';
import IdxRequest from './IdxRequest';
import { capitalCase } from 'change-case';
import { Loader as GMapLoader } from 'google-maps';

const isObject = function(val) {
    return val && typeof val === 'object' && val.constructor === Object;
}

axios.defaults.baseURL = process.env.MIX_API_BASE_URL;

export default {
    components: {
        Swiper,
        SwiperSlide,
        FsLightbox,
        IdxRequest,
    },
    data() {
        return {
            loading: true,
            view: 1,
            property: {
                Photos: [
                    {Uri1280: '/img/house-placeholder.png', Uri2048: '/img/house-placeholder.png'},
                ],
                UnparsedFirstLineAddress: '123 Main Street',
                City: 'Bar Harbor',
                StateOrProvince: 'ME',
                PostalCode: '04609',
                ListPrice: '500000',
                DaagyPropertyType: 'Single family',
                MlsStatus: 'Open',
                ListingId: '01234567',
                BedsTotal: '4',
                BathsFull: '2',
                BathsHalf: '1',
                LotSizeArea: '2',
                LotSizeUnits: 'acres',
                BuildingAreaTotal: '2500',
                GarageSpaces: '2',
                DaagyView: [],
                DaagyWaterfrontFeatures: [],
                PublicRemarks: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                ListOfficeName: 'Davis Agency',
                DaagyIdxLogoImage: 'https://daagy.mdiwebsites.com/img/Maine_IDX_Blue.jpg',
                DaagyIdxLogoText: '',
            },
            hasMap: true,
            compliance: null,
            thumbNav: false,
            swiperOption: {
                centeredSlides: true,
                autoHeight: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    // on: {
                    //     navigationNext: () => {
                    //         console.debug('main navigation.navigationNext');
                    //     },
                    //     nextClick: () => {
                    //         console.debug('main navigation.nextClick');
                    //     },
                    // },
                },
                // pagination: {
                //     el: '.swiper-pagination',
                //     type: 'bullets',
                // },
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                },
                keyboard: {
                    enabled: true,
                },
                // notNextTick: true,
                // thumbs: { swiper: this.thumbsSwiper },
                on: {
                    activeIndexChange: () => {
                        if (this.thumbNav) {
                            return;
                        }
                        this.$refs.swiperThumbs.$swiper.slideTo(this.$refs.swiperMain.$swiper.activeIndex);
                    },
                    // slideChange: () => {
                    //     console.debug('main slideChange');
                    // },
                    // navigationNext: () => {
                    //     console.debug('main navigationNext');
                    // },
                    // nextClick: () => {
                    //     console.debug('main nextClick');
                    // },
                },
            },
            swiperOptionThumb: {
                notNextTick: true,
                slidesPerView: 6,
                breakpoints: {
                    '@1.50': {
                        slidesPerView: 15,
                    },
                    '@1.00': {
                        slidesPerView: 9,
                    },
                    '@0.75': {
                        slidesPerView: 6,
                    },
                },
                slideToClickedSlide: true,
                centeredSlides: true,
                spaceBetween: 10,
                watchSlidesProgress: true,
                // preventClicks: false,
                // preventClicksPropagation: true,
                // touchEventsTarget: 'container',
                on: {
                    click: () => {
                        this.thumbNav = true;
                        this.$refs.swiperMain.$swiper.slideTo(this.$refs.swiperThumbs.$swiper.clickedIndex);
                        this.thumbNav = false;
                    },
                    breakpoint: (params) => {
                        console.debug('thumb breakpoint', params);
                    },
                },
                // onAny: (eventName, ...args) => {
                //     console.debug(eventName, args);
                // },
            },
            lightboxToggle: false,
            lightboxSlide: 0,
        };
    },
    computed: {
        lightboxPhotos() {
            return this.property.Photos.map(photo => photo.Uri2048);
        },
    },
    methods: {
        // Thumbs,
        setThumbsSwiper(swiper) {
            console.debug(swiper);
            this.thumbsSwiper = swiper;
        },
        openLightbox(iPhoto) {
            this.lightboxSlide = iPhoto + 1;
            this.lightboxToggle = true;
        },
        listDetails(fieldList) {
            return this.fieldLists[fieldList].map(field => ({
                label: this.getFieldLabel(field),
                value: this.stringifyField(field),
            })).filter(field => !!field.value);
        },
        getFieldLabel(field) {
            if (isObject(field)) {
                if (field.hasOwnProperty('label')) {
                    return field.label;
                }
                return capitalCase(field.name);
            }
            return capitalCase(field);
        },
        stringifyField(field) {
            let fieldName;
            let format;
            if (isObject(field)) {
                fieldName = field.name;
                format = field.hasOwnProperty('format') ? field.format : null;
            } else {
                fieldName = field;
                format = null;
            }

            if (!this.property.hasOwnProperty(fieldName) || this.property[fieldName] === null) {
                return null;
            }
            if (isObject(this.property[fieldName])) {
                return Object.keys(this.property[fieldName]).join('; ');
            }
            if (typeof this.property[fieldName] === 'boolean') {
                return this.property[fieldName] || null;
            }
            if (typeof this.property[fieldName] === 'string' && this.property[fieldName].match(/^\*+$/)) {
                return null;
            }
            switch(format) {
                case 'currency':
                    return '$' + this.property[fieldName].toLocaleString();
                default:
                    return this.property[fieldName];
            }
        },
    },
    created() {
        this.VIEWS = {
            description: 1,
            features: 2,
            land: 3,
            tax_deed: 4,
            map: 5,
        };
        this.view = this.VIEWS.description;

        this.fieldLists = {
            // main: [
            //     'MlsStatus',
            //     'PropertyType', 'PropertySubType', // DaagyPropertyType
            //     'StreetNumber', 'StreetName', // UnparsedFirstLineAddress
            //     'City',
            //     'PostalCode',
            //     'ListPrice',
            //     'BedsTotal',
            //     'BathsTotal',
            //     'BathsFull',
            //     'BathsHalf',
            //     'BuildingAreaTotal',
            //     // 'LivingArea', 'LivingAreaUnits', // almost always empty; use BuildingAreaTotal
            //     'LotSizeAcres', // 'LotSizeArea', 'LotSizeUnits', 'LotSizeSquareFeet',
            //
            //     // // currently only showing not-closed listings
            //     // 'CloseDate',
            //     // 'ClosePrice',
            //     // 'CurrentPrice',
            // ],
            features: [
                'Basement',
                'Electric',
                'Heating',
                'HeatingFuel',
                'Flooring',
                'ConstructionMaterials',
                'ArchitecturalStyle',
                'KitchenAppliances',
                'RoadSurfaceType',
                'ParkingFeatures',
                'ExteriorFeatures',
                'Sewer',
                'Roof',
                'Cooling',
                'FoundationDetails',
                'AccessibilityFeatures',
                'OtherEquipment',
                'GarageYN',
                'GarageSpaces',
                'YearBuilt',
                'CarportYN',
                'StoriesTotal',
                'RoomsTotal',
                'CoolingYN',
                'HeatingYN',
                'PoolYN',
                'Utilities',
                'FireplaceYN',
                // 'BuildingFeatures',
                // 'Location',
                // 'WaterSource',
            ],
            land: [
                'NumberOfUnitsBuildings',
                'AssociationFee',
                'NumberOfUnitsTotal',
                'WaterBodyName',
                'View',
                'WaterfrontFeatures',
                'BathsFull',
                'BathsHalf',
                'LotSizeAcres',
                'Zoning',
                'FireplacesTotal',
                'WaterFrontYN',
                // 'Survey', 'SurveyedYN', // requested but not in standardfields list
                // 'LandLeaseYN',
                // 'Surveyed',
                // 'ZoningOverlay',
            ],
            tax_deed: [
                { name: 'TaxBookNumber', label: 'Registry of Deeds Book #' },
                { name: 'TaxMapNumber', label: 'Tax Map #' },
                { name: 'TaxBlock', label: 'Tax Block #' },
                'TaxLot',
                { name: 'TaxAmount', format: 'currency' },
                'TaxYear',
                // 'ParcelNumber',
            ]
        };
    },
    mounted() {
        const vue = this;
        const listingId = (new URLSearchParams(window.location.search)).get('listing-id');
        axios.get('/api/idx-properties/' + listingId)
            .then(response => {
                vue.property = Object.assign({}, response.data.property);
                vue.compliance = Object.assign({}, response.data.compliance);
                vue.loading = false;

                // this.$nextTick().then(() => {
                //     const swiperMain = this.$refs.swiperMain.$swiper;
                //     const swiperThumbs = this.$refs.swiperThumbs.$swiper;
                //     swiperMain.params.control = swiperThumbs;
                //     swiperThumbs.params.control = swiperMain;
                // });

                if (!vue.property.Latitude || !vue.property.Longitude) {
                    vue.hasMap = false;
                    return;
                }
                const gmapLoader = new GMapLoader(process.env.MIX_GOOGLE_MAPS_API_KEY);
                gmapLoader.load().then(function (google) {
                    const latLng = { lat: vue.property.Latitude, lng: vue.property.Longitude };
                    const map = new google.maps.Map(document.getElementById('mapHolder'), {
                        center: latLng,
                        zoom: 16,
                    });
                    new google.maps.Marker({
                        position: latLng,
                        map,
                    });
                });
            })
        ;
    },
}
</script>

<style lang="scss">
.idxShow {
    //$slideshowHeight: 60vh;
    $slideshowHeight: min(60vh, calc(75vw));
    $slideshowMaxHeight: 60vh;

    .property {
        border: 1px solid black;
        padding: 0;
        margin: 10px auto;
        //max-width: 640px;
        max-width: 1600px;

        * {
            font-family: sans-serif;
            color: #000032;
        }

        .swiper {
            max-height: $slideshowMaxHeight;
            max-width: 100%;
        }

        .details {
            padding: 5px 10px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: flex-start;
            overflow: hidden;
            column-gap: 40px;
        }

        .address {
            //flex: 0 0 calc(100% - 6em);
            //font-size: 14pt;
            margin-bottom: 10px;
        }
        .address, .price {
            font-size: 5vw;
            vertical-align: top;

            @media(min-width: 800px) {
                font-size: 24pt;
            }
        }

        .street, .town {
            display: block;
        }

        .price {
            flex: 0 0 auto;
            //font-size: 14pt;
            font-weight: bold;
            text-align: right;
        }

        .listing-info, .property-info, .view, .waterfront {
            flex: 0 0 100%;
            display: flex;
            flex-wrap: wrap;
            column-gap: 5px;
            margin: 0;
            padding: 0;
            list-style-type: none;
            font-size: 4vw;

            @media(min-width: 800px) {
                font-size: 20pt;
            }
        }

        .listing-info, .property-info, .view, .waterfront {
            padding: 5px 0;
        }

        .listing-info {
            list-style-type: "|";

            li {
                padding: 0 5px;
            }

            li:first-of-type {
                list-style-type: none;
                padding-left: 0;
            }
        }

        .property-info {
            li {
                display: inline-block;
                text-align: center;
                border: 1px solid #aaa;
                border-radius: 5px;
                padding: 4px;
                font-weight: bold;
            }

            .nowrap {
                font-weight: normal;
            }

        }

        .view, .waterfront {
            margin: 2px 0;
            flex: 0 0 100%;
        }

        .desc {
            margin: 20px 0;
            font-size: 3.5vw;
            line-height: 1.4;

            @media(min-width: 800px) {
                font-size: 16pt;
            }
        }

        .listed-by {
            font-size: 2.5vw;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 5px 0;

            @media(min-width: 800px) {
                font-size: 12pt;
            }
        }

        .idx-logo-image img {
            width: 20vw;
            max-width: 120px;
        }

        .nowrap {
            white-space: nowrap;
        }


        .imgHolder, .thumbHolder {
            position: relative;
            //width: 640px;
            width: 100%;
            max-width: 1600px;
            overflow: hidden;
            height: $slideshowHeight;

            img {
                max-height: $slideshowMaxHeight;
                max-width: 100%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }

        .swiperMain.swiper-container {
            height: $slideshowHeight;
        }

        .swiperThumbs.swiper-container {
            height: 10vh;
        }

        .thumbHolder {
            height: 10vh;
            width: auto;

            img {
                max-height: 10vh;
            }
        }

        .swiper-pagination {
            padding: 5px;
            background-color: white;
            font-weight: bold;
            border-radius: 5px;

            display: inline-block;
            width: auto;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .property-compliance {
        display: flex;
        justify-content: space-between;
        padding: 5px 10px;
    }

    .compliance {
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-wrap: wrap;
        column-gap: 30px;
        margin: 0 auto 80px auto;
        //max-width: 640px;
        max-width: 1600px;

        p {
            text-align: justify;
            font-family: sans-serif;
            font-size: 10pt;
            flex: 0 0 100%;
            margin-bottom: 1em;
        }

        img {
            max-height: 8vw;
            max-width: 20vw;
        }
    }

    .loading {
        position: relative;
        overflow: hidden;
        pointer-events: none;
        opacity: 0.8;
        filter: blur(4px);
    }
    .loading::before {
        content: '';
        display: block;
        position: absolute;
        left: -150px;
        top: 0;
        height: 100%;
        width: 150px;
        background: linear-gradient(to right, transparent 0%, #cccccc 50%, transparent 100%);
        animation: load 1.5s cubic-bezier(0.4, 0.0, 0.2, 1) infinite;
    }
    @keyframes load {
        from {
            left: -150px;
        }
        to   {
            left: 100%;
        }
    }

    //button {
    //    font-size: 10pt;
    //    cursor: pointer;
    //    line-height: 0;
    //    border-style: solid;
    //    height: 0;
    //    border-radius: 24px;
    //    border-width: 12px;
    //    border-color: #101030;
    //    background-color: #101030;
    //    color: white !important;
    //    margin: 0 5px;
    //}

    #map {
        padding: 0;
    }
    #mapHolder {
        height: 50vh;
    }

    .tabs {
        list-style-type: none;
        padding: 0;
        text-align: center;

        button.active {
            font-weight: bold;
            box-shadow: 3px 3px 5px #555580;
            border-radius: 30px;
            border-width: 15px;
        }
    }
    .tab-content {
        padding: 5px 10px;
    }
    li {
        line-height: 1.4;
    }
    .label {
        font-weight: bold;
    }
}

// *************************************************

//.tabs-component {
//    margin: 4em 0;
//}

$tabs-min-width: 900px;

.tabs-component-tabs {
    border: solid 1px #ddd;
    border-radius: 6px;
    margin-bottom: 5px;
    padding: 0;
}

@media (min-width: $tabs-min-width) {
    .tabs-component-tabs {
        border: 0;
        align-items: stretch;
        display: flex;
        justify-content: flex-start;
        margin-bottom: -1px;
    }
}

.tabs-component-tab {
    font-size: 4vw;
    font-weight: 600;
    margin-right: 0;
    list-style: none;
    cursor: pointer;
    line-height: 1;
    background-color: #ddd;

    @media(min-width: $tabs-min-width) {
        font-size: 20pt;
    }
}

.tabs-component-tab.is-active {
    background-color: #fff;
}

//.tabs-component-tab:hover {
//    color: #666;
//}
//
//.tabs-component-tab.is-active {
//    color: #000;
//}

//.tabs-component-tab.is-disabled * {
//    color: #cdcdcd;
//    cursor: not-allowed !important;
//}

@media (min-width: $tabs-min-width) {
    .tabs-component-tab {
        border: solid 1px #333;
        border-bottom: dotted 1px #333;
        border-radius: 8px 8px 0 0;
        transform: translateY(2px);
        transition: transform .3s ease;
    }

    .tabs-component-tab.is-active {
        border-bottom: solid 1px #fff;
        z-index: 2;
        transform: translateY(0);
        list-style: none;
    }
}

.tabs-component-tab-a {
    align-items: center;
    color: inherit;
    display: flex;
    padding: .75em 1em;
    text-decoration: none;
}

.tabs-component-panels {
    padding: 4em 0;
}

@media (min-width: $tabs-min-width) {
    .tabs-component-panels {
        background-color: #fff;
        border: solid 1px #ddd;
        border-radius: 0 6px 6px 6px;
        box-shadow: 0 0 10px rgba(0, 0, 0, .05);
        padding: 4em 2em;
    }
}

</style>
